import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Whisper, Popover } from "rsuite";
import { FaRegEdit, FaRegEye } from "react-icons/fa";
import { Offcanvas } from "react-bootstrap";
import PharmacyPurchase from "../../pharmacy/PharmacyPurchase";
const ActionCellPurchase = ({ data }) => {
  const navigate = useNavigate();
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  // 👉 Reference for the Whisper trigger (to close popover manually)
  const whisperRef = useRef();

  // Function to close the popover and open the offcanvas
  const handleViewClick = () => {
    if (whisperRef.current) {
      whisperRef.current.close(); // Close the popover programmatically
    }
    setShowOffcanvas(true); // Then open the offcanvas
  };

  // Popover content (Edit + View)
  const renderPopover = (
    <Popover
      arrow={false}
      full
      className="p-2 rounded-md w-48 shadow-md border border-gray-200 bg-white"
    >
      <div className="px-3 pt-2 pb-1 text-sm font-semibold text-gray-800 border-b border-gray-100 mb-1">
        Actions
      </div>

 
      {/* <div
        onClick={() => {
          navigate("/AddBilling");
          if (whisperRef.current) whisperRef.current.close();
        }}
        className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 cursor-pointer rounded-md hover:bg-[#f6fef9]"
      >
        <FaRegEdit className="text-[#2fb06d]" />
        <span>Edit</span>
      </div> */}

      <div
        onClick={handleViewClick}
        className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 cursor-pointer rounded-md hover:bg-[#f6fef9]"
      >
        <FaRegEye className="text-[#2f3238]" />
        <span>View</span>
      </div>
    </Popover>
  );

  return (
    <>
      {/* ✅ Whisper with ref attached */}
      <Whisper
        ref={whisperRef}
        placement="autoVerticalEnd"
        trigger="click"
        speaker={renderPopover}
      >
        <button
          className="inline-flex items-center justify-center w-10 h-10 rounded-md hover:bg-gray-100 transition"
          title="More actions"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="lucide lucide-ellipsis h-4 w-4"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
          >
            <circle cx="12" cy="12" r="1" />
            <circle cx="19" cy="12" r="1" />
            <circle cx="5" cy="12" r="1" />
          </svg>
        </button>
      </Whisper>
<Offcanvas
  show={showOffcanvas}
  onHide={() => setShowOffcanvas(false)}
  placement="end"
  backdrop="true"
  className="!w-[70%] bg-white shadow-2xl border-l border-gray-200"
>

        <Offcanvas.Header closeButton className="!border-b !border-gray-200">
          <Offcanvas.Title className="text-lg font-bold text-gray-800">
         Distributor Details
          </Offcanvas.Title>
        </Offcanvas.Header>

      <Offcanvas.Body>
  <PharmacyPurchase distributorData={data} />
</Offcanvas.Body>

      </Offcanvas>
    </>
  );
};

export default ActionCellPurchase;
